import React from 'react'
import { Button, TextField, useTheme } from '@mui/material'
import BrandCard from '../Card/BrandCard'

const LoginSkeleton: React.FC = () => {
  const theme = useTheme()

  return (
    <div aria-label="login-skeleton">
      <BrandCard
        minimumScreenHeight={510}
        cardContent={
          <>
            <TextField
              variant="filled"
              margin="normal"
              fullWidth
              disabled
              label="Email"
            />
            <TextField
              variant="filled"
              margin="normal"
              fullWidth
              disabled
              label="Password"
              sx={{ mt: 4 }}
            />
          </>
        }
        cardActions={
          <>
            <Button
              variant="contained"
              fullWidth
              disabled
              disableElevation
              sx={{
                mt: theme.spacing(2),
                mb: theme.spacing(2),
                flexGrow: 1,
                width: '96.75%',
                p: 1.5,
              }}
            />
          </>
        }
      />
    </div>
  )
}

export default LoginSkeleton
